import './aboutUs.css';
import Team from '../../assets/team.jpg';
import Enes from '../../assets/team/enes.jpg';

function AboutUs() {
  return (
      <div className="pageContainer">
        {/* HEADER SECTION */}
        <section className='aboutUsHeader'>
          <div className='aboutUsHeaderText'>
            <h1 className='aboutUsHeading'>Lerne unser Team und unsere Geschichte kennen</h1>    
            <div>
              <p>Gegründet aus der Not heraus: Mein Vater ist selbstständig und braucht Rechnungen. Also baue ich eine Software, die das kann.</p>
              <p>Wenn dich die ganze Geschichte interessiert, guck unter "Unsere Geschichte".</p>  
            </div>    
          </div>
          <img src={Team} alt='Team' className='aboutUsImg' />
        </section>
        <section>
          <h2 className='aboutUsHeading'>Unsere Geschichte</h2>    
          {/* Hieraus später eine eigene Komponente machen, kann auch in diesem Zitatding verwendet werden */}
          <div className='aboutUsContainer'>
            <div className='aboutUsCard'>
              <h3>Anfang 2024</h3>
              <p>Mein Vater macht sich im Eventmanagement selbstständig. Ich erstelle seine Rechnungen über eine Software.</p>
            </div>
            <div className='aboutUsCard'>
              <h3>Juni 2024</h3>
              <p>Die Software kostet ab einer bestimmten Anzahl an Kunden Geld. Also beschließe ich selber eine kleine Software für meinen Vater zu bauen, mit welcher er Rechnungen erstellen kann.</p>
              <p>Diese poste ich auf Instagram, um sie meinen Freunden zu zeigen. Ich bekomme viel positives Feedback, Freunde fragen, ob sie die Software verwenden können und ich beschließe daraus eine Firma zu gründen und die Software so zu bauen, dass alle sie verwenden können.</p>
              <p>Hier taucht aber ein Problem auf: Ich kann nicht wirklich gut programmieren. Da es anfangs aber ein Hobbyprojekt ist, kommt jemanden einstellen nicht in Frage.</p>
              <p>Ich habe ja keine Eile, also beschließe ich erst das Nötige zu lernen, damit ich die Software erstmal gänzlich alleine bauen kann.</p>
            </div>
            <div className='aboutUsCard'>
              <h3>Juni 2024 - Dezember 2024</h3>
              <p>Ich hole mir also einen Online Kurs, der alles abdeckt, was ich brauche und fange an.</p>
              <p>Das stellt sich jedoch als schwierig dar, weil ich vollzeit studiere und als Werkstudent arbeite.</p>
              <p>Aufgeben ist aber keine Option - ich glaube an dieses Projekt und liebe es zu programmieren. Also Augen zu und durch!</p>
            </div>
            <div className='aboutUsCard'>
              <h3>Januar 2025</h3>
              <p>Der Kurs ist durch. Ich bin aufgeregt. Ich habe zu diesem Zeitpunkt vor vier Jahren angefangen programmieren zu lernen, mit dem Ziel eines Tages die Website für mein eigenes Unternehmen zu bauen.</p>
              <p>Über die Jahre wurde programmieren immer mehr zum Hobby. Mittlerweile wollte ich sogar als Programmierer arbeiten, aber es stellte sich als sehr schwierig dar, als Quereinsteiger etwas zu finden.</p>
              <p>Dieses Jahr soll aber mein Jahr werden! Ich fange am Januar meinen ersten Job als Programmierer an und fange gleichzeitig mit dem Bauen der Software für meine erste Firma an.</p>
            </div>
            <div className='aboutUsCard'>
              <h3>Februar 2025</h3>
              <p>Die Prüfungsphase beginnt. In der Zeit kann ich kaum an dem Projekt weiterarbeiten. Das demotiviert mich etwas, weil ich mit viel Vorfreude an dem Projekt saß.</p>
              <p>Aber das gehört einfach zur Gründung dazu. Es gibt gerade am Anfang sehr stressige Phasen, und dieser sollte bald ein kleiner Schicksalsschlag folgen.</p>
            </div>
            <div className='aboutUsCard'>
              <h3>März 2025</h3>
              <p>Ich bekomme die Note eines Drittversuchs. Nicht bestanden. Das bedeutet ich fliege, ein Semester vor Ende meines Studiums, von der Uni.</p>
              <p>Gerade am Anfang trifft mich das sehr hart. Was mache ich jetzt? Ich will nicht nochmal neu anfangen, also muss ein Plan B her.</p>
              <p>Zwei Möglichkeiten: Gründung oder einen Job suchen.</p>
              <p>Und wir sind so ziemlich in der Gegenwart angekommen, ich halte euch auf dem Laufenden.</p>
            </div>
          </div>
        </section>
        <section className='aboutUsTeamContainer'>
          <h2 className='aboutUsHeading'>Unser Team</h2>    
          <img src={Enes} alt='Enes Gürleyen' className='aboutUsTeamImg' />
          <h3 className='aboutUsTeamDescription'>Enes Gürleyen, Gründer</h3>
        </section>
      </div>
  );
}

export default AboutUs;